import { object, ObjectSchema } from 'yup';
import {
  REQUIRED_TEXT_FIELD_VALIDATOR,
  REQUIRED_VALIDATION_MESSAGE,
  STRING_VALIDATOR,
} from '@/helpers/formHelpers/validators';

export const EDIT_API_KEY_VALIDATION: ObjectSchema<{ name: string }> = object({
  name: REQUIRED_TEXT_FIELD_VALIDATOR,
});

export const CREATE_API_KEY_VALIDATION = object({
  date_expired: STRING_VALIDATOR.required(REQUIRED_VALIDATION_MESSAGE),
}).concat(EDIT_API_KEY_VALIDATION);
